import React, { Component } from 'react';

class GrochatCancel extends Component {
    componentDidMount() {
        window.close();
    }

    render() {
        return (
            <></>
        );
    }
}

export default GrochatCancel;